import React from 'react';

import type { FlagIconProps } from './icon-types';

export const FlagGermany: React.FC<FlagIconProps> = ({ size, isCircle = true }) => (
  <svg
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size }}
  >
    <defs>
      {isCircle && (
        // eslint-disable-next-line react/no-unknown-property
        <mask id="circle" mask-type="luminance">
          <circle cx="63" cy="63" r="63" fill="white" />
        </mask>
      )}
    </defs>
    <g mask={isCircle ? 'url(#circle)' : undefined}>
      <path d="M126 0H0V42H126Z" fill="#231F20" />
      <path d="M126 42H0V84H126Z" fill="#EC1C24" />
      <path d="M126 84H0V126H126Z" fill="#FFCA05" />
    </g>
  </svg>
);
